import { useCallback, useEffect, useRef, useState } from 'react';

interface UseTimedBlockerOptions {
	active: boolean; // Si el temporizador debe estar activo
	duration: number; // Duración en segundos
}

interface UseTimedBlockerResult {
	isBlocked: boolean; // Si está actualmente bloqueado
	remainingTime: number; // Tiempo restante en segundos
	reset: () => void; // Reiniciar el temporizador
}

export const useTimedBlocker = ({
	active,
	duration,
}: UseTimedBlockerOptions): UseTimedBlockerResult => {
	const [remainingTime, setRemainingTime] = useState<number>(0);
	const intervalRef = useRef<NodeJS.Timeout | null>(null);

	const isBlocked = remainingTime > 0;

	const reset = useCallback(() => {
		clearInterval(intervalRef.current!);
		setRemainingTime(duration);

		intervalRef.current = setInterval(() => {
			setRemainingTime((prev) => {
				if (prev <= 1) {
					clearInterval(intervalRef.current!);
					return 0;
				}
				return prev - 1;
			});
		}, 1000);
	}, [duration]);

	useEffect(() => {
		if (active) {
			reset();
		} else {
			clearInterval(intervalRef.current!);
			setRemainingTime(0);
		}

		return () => clearInterval(intervalRef.current!);
	}, [active, duration, reset]);

	return {
		isBlocked,
		remainingTime,
		reset,
	};
};
